export class LanguageConstants {
    static readonly key: string = '130355';
    static readonly en: string = 'en';
    static readonly th: string = 'th';

    static readonly labelEn: string = 'EN';
    static readonly labelTh: string = 'TH';
}